import { Globe, Search } from "lucide-react";

import { ListCard, ListRow, ListTile } from "@/shared/components/ListCard";
import { Note } from "@/shared/components/settings-atoms";
import { WEB_TOOLS } from "../hooks/useApprovalOptions";
import Section from "./Section";

import type { ConfigSection } from "../ConfigSectionHelp";
import type { Agent } from "@/shared/types";

const ICONS: Record<string, typeof Globe> = { web_search: Search, web_fetch: Globe };

export default function WebSection({ agent, onUpdateAgent, onHelp }: {
  agent: Agent;
  onUpdateAgent: (updater: (a: Agent) => Agent) => void;
  onHelp: (section: ConfigSection) => void;
}) {
  const enabled = !!agent.capabilities?.webEnabled;
  const toggle = () => onUpdateAgent((a) => ({ ...a, capabilities: { ...a.capabilities, webEnabled: !enabled } }));

  return (
    <Section section="web" onHelp={onHelp} enabled={enabled} onToggle={toggle}>
      <ListCard label="Tools">
        {WEB_TOOLS.map(({ name, desc }) => {
          const Icon = ICONS[name];
          return (
            <ListRow
              key={name}
              lead={<ListTile><Icon className="w-4 h-4" strokeWidth={1.75} /></ListTile>}
              title={<span className="font-mono">{name}</span>}
              desc={desc}
            />
          );
        })}
      </ListCard>
      <Note>
        It reads public pages only: anything behind a sign-in stays out of reach. Publish to make
        new conversations get the change.
      </Note>
    </Section>
  );
}
